var i4_Group = {
    factory: function() {
        return new i4_Group_instance(this.index);
    }
};

var i4_Group_instance = function() {

    this.id = '';
    this.index = 0;
    this.open = true;
    this.hashtag = '';
    this.open_one = '';

    this.initialize = function(index) {
        this.index = index;

        // defaults
        this.id = '';
        this.open = true;
        this.hashtag = '';
        this.open_one = '';

    };

    this.set_id = function(id) {
        this.id = id;
        return this;
    };

    this.set_open = function(open) {
        this.open = open;
        return this;
    };

    this.set_hashtag = function(hashtag) {
        this.hashtag = hashtag;
        return this;
    };

    this.set_open_one = function(open_one) {
        this.open_one = open_one;
        return this;
    };

    this.toggle = function (event) {
        var elements = document.querySelectorAll('.target_' + this.id);
        [].forEach.call(elements, function (item) {
                item.classList.toggle('c-group--open');
            }
        );
        var element = document.querySelector('.toggler_' + this.id);
        element.classList.toggle('item-group--open');
        event.stopPropagation();
    };

    this.run = function() {

        if (document.getElementById(this.id)) {

            var toggler = document.getElementById(this.id).parentElement;
            toggler.addEventListener('click', this.toggle.bind(this), false);

            var item = toggler;

            while(item) {
                if (item.classList) {
                    if (item.classList.contains('c-aggregator__item--group')) {
                        item.classList.add('toggler_' + this.id);
                        if (this.hashtag != '') {
                            item.classList.add('c-group__hashtag--' + this.hashtag);
                        }
                        if (this.open) {
                            item.classList.add('item-group--open');
                        }
                    } else {
                        item.classList.add('c-group--target');
                        item.classList.add('target_' + this.id);
                        if (this.open) {
                            item.classList.add('c-group--open');
                        }
                        if (this.hashtag != '') {
                            item.classList.add('c-group__hashtag--' + this.hashtag);
                        }
                    }
                }
                item = item.nextSibling;
                if (item != null && item.classList && item.classList.contains('c-aggregator__item--group')) {
                    item = false;
                }
            }
        }

        if (document.querySelector('.group_end')) {
            var element = document.querySelector('.group_end');
            element.parentElement.classList.add('group_end');
        }
    };
};
